import _ from "underscore";

/********************************************************
 *
 * Ajax helpers
 *  Backdraft compliant
 *
 ********************************************************/

import ExceptionHandling from "./logging/exception_handling";

import Flash from "./flash";

import jQuery from "jquery";

const Ajax = {};

Ajax.SERVER_ERROR_DEFAULT_MESSAGE = 'Sorry, an error occurred.';
Ajax.COMMUNICATION_ERROR_MESSAGE = 'Sorry, the request could not be made. Please ensure you have disabled ad blockers for this domain .';
Ajax.TIMEOUT_STATUS = 'timeout';
Ajax.PARSE_ERROR_STATUS = 'parsererror';

Ajax.getCsrfToken = function() {
  return jQuery("meta[name='csrf-token']").attr("content");
};

Ajax.onComplete = function(result, responseText) {
  if (result.textStatus === Ajax.TIMEOUT_STATUS) {
    ExceptionHandling.logWarning("Invoca.Ajax: request timed out");
  } else if (result.textStatus === Ajax.PARSE_ERROR_STATUS) {
    ExceptionHandling.logError("Invoca.Ajax: parse error on ajax, response: " + responseText);
    // could also listen for "error" callback and log the 'errorThrown' parameter
  }

  if (!result.success) {
    // if ajax is cancelled, there is no message, so we don't want to show a flash (such as if user navigates away before a grid loads)
    if (result.message) {
      Flash.showError(result.message);
    }
  }
};

Ajax.parseResponse = function(xhr) {
  var status = xhr.status;
  var message;
  var textStatus;
  var success;

  switch (status) {
  case 0:
    if (xhr.statusText === 'error') {
      message = Ajax.COMMUNICATION_ERROR_MESSAGE;
      textStatus = 'error';
    } else {
      message = '';
      textStatus = 'cancelled';
    }

    success = false;
    break;

  case 200:
  case 201:
  case 304:
    message = Ajax._messageFromResponse(xhr);
    success = true;
    break;

  case 401: // not authorized
  case 422: // validation error
    message = Ajax._messageFromResponse(xhr);
    success = false;
    break;

  case 504: // timeout - using for database query timeouts to communicate to customer
    message = Ajax.defaultErrorMessageWithTimestamp(xhr);
    textStatus = Ajax.TIMEOUT_STATUS;
    success = false;
    break;

  case 404: // not found
  case 405: // not allowed
  case 406: // not acceptable
  case 500: // exception
  case 502: // unicorn timed out
  case 503: // unicorns not available
  default:
    // error
    message = Ajax.defaultErrorMessageWithTimestamp(xhr);
    success = false;
  }

  return {
    status:     status,
    success:    success,
    textStatus: textStatus,
    message:    message };
};

/**
 * Parses server errors into an array for iteration and display
 * Consumer can do `messages.join(', ')` or `messages.join('<br />')` etc to get a formatted string for display
 *
 * @param {Object} response - the entire (XHR) response object from a remote call
 * @returns {Array} an array of messages
 */
Ajax.errorMessages = function(response) {
  var json = Ajax._responseJSON(response);

  if (json && json.errors) {
    return Ajax.parseErrorMessages(json.errors);
  } else {
    var parsedResponse = Ajax.parseResponse(response);
    return [parsedResponse.message];
  }
};

/**
 * Converts server errors from a hash into an array of human readable messages
 *
 * @param {Object} errorsHash - the hash of errors to display (UI may have already filtered or modified the list)
 * @returns {Array} an array of messages, same as `Ajax.errorMessages`
 */
Ajax.parseErrorMessages = function(errorsHash) {
  var messages = [];

  if (typeof errorsHash === 'string') {
    messages.push(errorsHash);
  } else if (_.isArray(errorsHash)) {
    messages = errorsHash;
  } else {
    messages = Ajax._normalizeMessagesWithKeys(errorsHash);
  }

  return Ajax._filterMessages(messages);
};

Ajax.defaultErrorMessageWithTimestamp = function(response) {
  var json = Ajax._responseJSON(response);
  var timestamp = json && json.time_t;
  if (timestamp) {
    return [Ajax.SERVER_ERROR_DEFAULT_MESSAGE, ' Please refer to error #', timestamp].join('');
  } else {
    return Ajax.SERVER_ERROR_DEFAULT_MESSAGE;
  }
};

Ajax._normalizeMessagesWithKeys = function(errorsHash) {
  var errorNames = Object.keys(errorsHash);
  var messages   = [];

  errorNames.forEach(function(name) {
    var prefix = '';

    if (name !== 'invalid_data') {
      prefix = name[0].toUpperCase() + name.slice(1).replace(/_/g, ' ') + ' ';
    }

    messages.push(prefix + errorsHash[name]);
  });

  return messages;
};

Ajax._filterMessages = function(messages) {
  // all lowercase to be case insensitive
  var messagesToSkip = ['class recordinvalid', 'class recordnotfound'];

  var filtered = messages.filter(function(message) {
    return messagesToSkip.indexOf(message.toLowerCase()) === -1;
  });

  return filtered;
};

Ajax._messageFromResponse = function(xhr) {
  var responseJson, jsonMessage, jsonErrors;

  // XHR requests should return json with a "message" param
  //  but if anything happens when parsing that (including for old interfaces that still return text),
  //  just set entire responseText as the message
  responseJson = Ajax._responseJSON(xhr);
  jsonErrors = responseJson && responseJson.errors;
  jsonMessage = (responseJson && responseJson.message) || (jsonErrors && (jsonErrors.invalid_data || jsonErrors[Object.keys(jsonErrors)[0]]));

  return jsonMessage || xhr.responseText;
};

Ajax._responseJSON = function(xhr) {
  try {
    if (xhr) {
      return xhr.responseJSON ? xhr.responseJSON : JSON.parse(xhr.responseText);
    }
  } catch (ex) {}
};

export default Ajax;
